module.exports = __webpack_public_path__ + "media/shared/assets/fonts/Rubik/Rubik-Regular-55fa11cdc8b9a3ee842fbb554733127c.ttf";